/* Capsi PDP (Concept 3) renderer.
 * Reads window.CAPSI_PDP (emitted by templates/product.liquid) + the baked
 * catalogs (pdp-packs.js, pdp-editorial.js) and renders the product page body.
 * Commerce stays server-side: the Liquid {% form 'product' %} + hidden inputs are
 * driven here (selling_plan), and theme.js handles AJAX add-to-cart + cart drawer. */
(function () {
  var PDP = window.CAPSI_PDP;
  if (!PDP) return;
  var root = document.getElementById("capsi-pdp-root");
  if (!root) return;

  var DATA = (window.CAPSI_PACK_DATA || { packs: {}, ingredients: {} });
  var ED = (window.CAPSI_PACK_EDITORIAL || {});
  var pack = DATA.packs[PDP.handle] || { name: PDP.title, pills: [] };
  var ed = ED[PDP.handle] || { goal: (PDP.type || "daily"), sub: "", curatedWhy: "a considered daily formula" };
  var ING = DATA.ingredients || {};
  var pills = pack.pills || [];
  var N = pills.length;

  function esc(s){ return String(s == null ? "" : s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;"); }
  function money(cents){ return "$" + (cents/100).toFixed(2); }
  /* Shipping copy comes from the store's real Shopify rates (window.theme.shipping,
     emitted in layout/theme.liquid from the theme's Shipping settings) so the PDP
     can't drift from what checkout charges. */
  var SHIPCFG = (window.theme && window.theme.shipping) || {};
  var SHIP_FREE_OVER = typeof SHIPCFG.freeOver === "number" ? SHIPCFG.freeOver : 100;
  var SHIP_SUBS_FREE = SHIPCFG.subscriptionsFree !== false;
  function amount(dollars){ return "$" + (Math.round(dollars*100)%100 === 0 ? String(Math.round(dollars)) : dollars.toFixed(2)); }
  /* what this tier actually ships for: subscriptions ship free while the store
     offers a zero-cost rate on them; otherwise it's the amount charged now that
     has to clear the free-shipping threshold. */
  function shipNote(t){
    if (t.kind === "plan" && SHIP_SUBS_FREE) return "Free shipping on every subscription order.";
    var chargedCents = (t.kind === "plan" && t.total) ? t.total : t.price;
    if (chargedCents/100 >= SHIP_FREE_OVER) return "Free shipping on this order.";
    return "Free shipping over " + amount(SHIP_FREE_OVER) + ".";
  }
  function perDay(cents){ return "less than $" + Math.ceil(cents/100/30); }

  /* ---------------- pricing tiers from real selling plans ---------------- */
  function cadenceOf(name){
    var n = (name||"").toLowerCase();
    if (/(^|\D)(3\s*month|three\s*month|quarter)/.test(n)) return "quarter";
    if (/month/.test(n)) return "month";
    return "sub";
  }
  var planTiers = (PDP.plans || []).map(function(p){
    var cad = cadenceOf(p.name);
    /* Two multi-month plan shapes must both render as per-month:
       - native prepaid: perDelivery is already the per-month figure (< price).
       - custom-price bundle (current Seal setup): "deliver every 3 months" at a
         fixed base×3×0.75, so perDelivery == price == the full bundle — split it
         across the cadence's months instead.
       `total` keeps the full billed amount for the "Billed $X every N months" note. */
    var months = cad === "quarter" ? 3 : 1;
    var perDel = (p.perDelivery != null ? p.perDelivery : p.price);
    var deliveries = (perDel > 0 && perDel < p.price) ? Math.max(1, Math.round(p.price / perDel)) : months;
    var perMo = Math.round(p.price / deliveries);
    var save = PDP.oneTimePrice ? Math.round((PDP.oneTimePrice - perMo) / PDP.oneTimePrice * 100) : 0;
    return { kind:"plan", id:p.id, cad:cad, price:perMo, total:p.price, deliveries:deliveries, name:p.name, save:save };
  });
  // order subscriptions best-value first: 3-month, then monthly, then any other
  var ORDER = { quarter:1, month:2, sub:3 };
  planTiers.sort(function(a,b){ return (ORDER[a.cad]||3) - (ORDER[b.cad]||3); });
  var tiers = planTiers.slice();
  if (PDP.oneTimePrice) tiers.push({ kind:"onetime", id:"", cad:"once", price:PDP.oneTimePrice, name:"One-time", save:0 });

  function tierLabel(t){
    if (t.kind === "onetime") return "One-time";
    if (t.cad === "month") return "Monthly";
    if (t.cad === "quarter") return "3-month routine";
    return t.name;
  }
  function tierDesc(t){
    if (t.kind === "onetime") return "A single 30-day pack";
    if (t.cad === "month") return "Billed monthly";
    if (t.cad === "quarter") return (t.total && t.deliveries > 1)
      ? "Billed " + money(t.total) + " every " + t.deliveries + " months"
      : "Billed every 3 months";
    return t.name;
  }
  var maxSave = 0, maxIdx = -1;
  tiers.forEach(function(t,i){ if (t.save > maxSave){ maxSave = t.save; maxIdx = i; } });
  // default to the best-value subscription (3-month), else monthly, else first
  var sel = tiers.findIndex(function(t){ return t.cad === "quarter"; });
  if (sel < 0) sel = tiers.findIndex(function(t){ return t.cad === "month"; });
  if (sel < 0) sel = 0;
  // ?plan=monthly|3month|once (or onetime) preselects a tier, so an email quoting the Monthly price lands on Monthly
  try {
    var wantPlan = ({ monthly:"month", "3month":"quarter", once:"once", onetime:"once" })[new URLSearchParams(location.search).get("plan")];
    var wantIdx = wantPlan ? tiers.findIndex(function(t){ return t.cad === wantPlan; }) : -1;
    if (wantIdx >= 0) sel = wantIdx;
  } catch (e) {}

  function tierUnit(t){ return t.kind === "onetime" ? "one-time" : "per month"; }
  function ctaText(t){
    return (t.kind === "onetime")
      ? "Add to cart · " + money(t.price)
      : "Subscribe · " + money(t.price) + "/mo";
  }

  /* ---------------- gallery ---------------- */
  var images = PDP.images || [];
  var gActive = 0;

  /* ---------------- shared content ---------------- */
  var EXCL = [
    { w:"No proprietary blends", d:"You can see every ingredient and its exact dose above." },
    { w:"No fillers or bulking agents", d:"We don't add anything just to bulk out a capsule." },
    { w:"No magnesium stearate", d:"We skip synthetic flow agents used to speed up manufacturing." },
    { w:"No added sugar or sweeteners", d:"A daily routine shouldn't sneak in sugar." },
    { w:"No artificial colors", d:"Capsules are clear; nothing is dyed for looks." },
    { w:"No gluten or dairy", d:"Made to suit most everyday routines." }
  ];
  var TL = [
    { when:"Week 1", h:"Getting started", b:"Take one packet a day with a meal. You probably won't feel anything dramatic yet, which is normal." },
    { when:"Week 4", h:"Give it time", b:"With daily use, some nutrients may begin reaching steadier levels in your system." },
    { when:"Month 2 and beyond", h:"Staying with it", b:"This is a daily foundation, so the benefit comes from staying consistent over time." }
  ];
  /* plain text: the FAQ renderer escapes q and a, so escaping here too printed
     titles like "Women's Wellness" as "Women&#39;s Wellness" */
  var FAQ = [
    { q:"How is the " + PDP.title + " curated?",
      a:"Our team selects " + ed.curatedWhy + ". Everything in the packet is chosen to be taken together, and we publish every form and dose in full so you can see exactly what you're taking before you buy. It's one considered formula, the same for everyone who picks this pack, not something generated from an assessment." },
    { q:"Can I take this alongside medication?",
      a:"Capsi packs are supplements, not prescription medication, however supplements can still interact with prescriptions or affect how they're absorbed, so check with your doctor or pharmacist before starting anything new." },
    { q:"What if I already take some of these?",
      a:"The full formula, with every form and dose, is published on this page. If you already take something on that list, show it to your doctor or pharmacist and they can tell you whether to keep both, drop one, or adjust. We'd rather you check with them than guess." },
    { q:"How does the subscription work?",
      a:"We offer monthly and 3-month plans. The 3-month plan is paid upfront and saves 25%, and your packs still arrive one month at a time. Your subscription renews automatically until you change it, and you can switch schedules at any time." },
    { q:"How do I cancel or pause?",
      a:"Log in to your account and open Subscriptions, where you can skip a shipment, pause, or cancel. Every subscription email also links straight there. Changes apply to your next order as long as you make them before it's charged, and there's no phone call and no fee. If anything goes wrong or you can't find what you need, email support@shopcapsi.com and we'll sort it out." },
    { q:"Is the packaging recyclable?",
      a:"Yes, the whole pack is made to be recycled. The daily packets are recyclable, and they ship in a recyclable, FSC-certified cardboard carton. Because a full day is pre-measured into one packet, the format uses about 80% less plastic than buying the same routine as separate bottles, and every order ships carbon-neutral." }
  ];

  /* ---------------- hero bits ---------------- */
  var topPills = pills.slice(0,3).map(function(p){ return p.name; });
  var pillPhrase = topPills.length === 3 ? topPills[0]+", "+topPills[1]+" and "+topPills[2]
                 : topPills.join(" and ");
  var benefits = [
    pillPhrase + ", chosen for " + ed.goal + " support",
    "A fully transparent label with no proprietary blends",
    "Third-party tested in independent US labs"
  ];
  /* Eco benefit renders last with a recycling mark instead of the check. */
  var ECO_BENEFIT = "Recyclable packet, 80% less plastic than bottles";
  var RECYCLE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
    '<path d="M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5"/>'+
    '<path d="M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12"/>'+
    '<path d="m14 16-3 3 3 3"/>'+
    '<path d="M8.293 13.596 7.196 9.5 3.1 10.598"/>'+
    '<path d="m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843"/>'+
    '<path d="m13.378 9.633 4.096 1.098 1.097-4.096"/>'+
    '</svg>';

  /* thumbs only need a small render, not the full 1100px hero file */
  function thumbSrc(src){ return String(src).replace(/([?&]width=)\d+/, '$1320'); }
  function galleryHTML(){
    if (!images.length){
      return '<div class="h-gallery gallery"><div class="main" data-track><div class="ph">Product image</div></div></div>';
    }
    var slides = images.map(function(src,i){
      return '<div class="slide"><img src="'+esc(src)+'" alt="'+esc(PDP.title)+(images.length>1?', view '+(i+1):'')+'"'+(i===0?' loading="eager" fetchpriority="high"':' loading="lazy"')+'></div>';
    }).join("");
    var thumbs = (images.length > 1) ? images.map(function(src,i){
      return '<button type="button" class="t'+(i===gActive?' active':'')+'" data-g="'+i+'" aria-label="Show image '+(i+1)+' of '+images.length+'"'+(i===gActive?' aria-current="true"':'')+'><img src="'+esc(thumbSrc(src))+'" alt="" loading="lazy"></button>';
    }).join("") : "";
    return '<div class="h-gallery gallery">'+
           '<div class="main" data-track>'+slides+'</div>'+
           (thumbs ? '<div class="thumbs">'+thumbs+'</div>' : '')+
           '</div>';
  }
  function benefitsHTML(){
    var rows = benefits.map(function(b){
      return '<div class="b"><span class="tick">✓</span><span>'+esc(b)+'</span></div>';
    }).join("");
    rows += '<div class="b eco"><span class="tick">'+RECYCLE_SVG+'</span><span>'+esc(ECO_BENEFIT)+'</span></div>';
    return '<div class="h-benefits benefits">'+ rows +'</div>';
  }

  function tiersHTML(){
    return tiers.map(function(t,i){
      var priceTxt = (t.kind === "onetime") ? money(t.price) : money(t.price)+'<small>/mo</small>';
      var save = t.save > 0
        ? "Save "+t.save+"%" + (t.cad==="quarter" ? " + free shipping" : "")
        : (t.cad==="quarter" ? "Free shipping" : "");
      var badge = (i === maxIdx && t.save > 0) ? '<span class="badge">Best value</span>' : '';
      return '<button type="button" class="tier'+(badge?' badged':'')+(i===sel?' active':'')+'" data-t="'+i+'">'+
        '<span class="radio"></span><div class="body">'+
          '<div class="row"><span class="lab">'+esc(tierLabel(t))+'</span><span class="permo">'+priceTxt+'</span></div>'+
          '<div class="row" style="margin-top:3px"><span class="desc">'+esc(tierDesc(t))+'</span><span class="save">'+save+'</span></div>'+
        '</div>'+badge+'</button>';
    }).join("");
  }

  function ledgerHTML(){
    return pills.map(function(p){
      var info = ING[p.name] || { why:"", tags:"" };
      var dose = p.dose ? esc(p.dose) : "complex";
      return '<div class="ing"><div class="top"><div><span class="nm">'+esc(p.name)+'</span></div>'+
        '<span class="dose">'+dose+'</span></div>'+
        (info.why ? '<p class="why">'+esc(info.why)+'</p>' : '')+
        (info.tags ? '<div class="tags">'+esc(info.tags)+'</div>' : '')+'</div>';
    }).join("");
  }

  /* ---------------- assemble ---------------- */
  root.innerHTML =
    '<div class="wrap">'+
      '<a class="back-link" href="/collections/packs">&lsaquo; See all packs</a>'+
      '<section class="hero">'+
        '<div class="h-title buybox">'+
          '<h1>'+esc(PDP.title)+'</h1>'+
          (ed.sub ? '<p class="sub">'+esc(ed.sub)+'</p>' : '')+
        '</div>'+
        galleryHTML() +
        '<div class="h-card">'+
          '<div class="card">'+
            '<div style="font-size:13px;font-weight:600">Choose your routine</div>'+
            '<div class="price"><span class="big" id="cpd-big"></span><span class="unit" id="cpd-unit"></span></div>'+
            '<div class="priceline" id="cpd-line"></div>'+
            '<div class="tiers" id="cpd-tiers">'+ tiersHTML() +'</div>'+
            '<button type="submit" class="btn-primary cta" id="cpd-cta"'+(PDP.available?'':' disabled')+'></button>'+
            '<div class="ship" id="cpd-ship"></div>'+
            '<div class="reassure">'+
              '<div><div class="h">Automatic shipments</div><div class="s">Never run out</div></div>'+
              '<div><div class="h">Flexible</div><div class="s">Skip or pause anytime</div></div>'+
              '<div><div class="h">Cancel anytime</div><div class="s">In two clicks</div></div>'+
            '</div>'+
          '</div>'+
        '</div>'+
        benefitsHTML() +
      '</section>'+

      '<section class="trust">'+
        '<div style="flex:1 1 360px;min-width:280px">'+
          '<div class="certs"><span>cGMP</span><span>UL-Certified</span><span>ISO-17025 labs</span><span>Non-GMO</span><span>Third-party tested</span><span>Recyclable packaging</span></div>'+
          '<p class="prove">FDA-compliant cGMP facility. Every batch third-party tested.</p>'+
        '</div>'+
      '</section>'+

      '<section style="padding-bottom:50px"><div class="sec-head"><h2>What to expect over time</h2></div>'+
        '<div class="tl">'+ TL.map(function(t){ return '<div class="tlc"><div class="when"><span class="d"></span>'+esc(t.when)+'</div><h3>'+esc(t.h)+'</h3><p>'+esc(t.b)+'</p></div>'; }).join("") +'</div></section>'+

      '<section><div class="ledger-head"><div><h2>What\'s inside</h2></div>'+
        '<p class="note">Every nutrient and its exact dose. No proprietary blends.</p></div>'+
        '<div class="ledger-grid">'+ ledgerHTML() +'</div></section>'+

      '<section><div class="leftout"><h2>What we left out</h2><div class="grid">'+
        EXCL.map(function(e){ return '<div class="x"><span class="m">×</span><div><div class="w">'+esc(e.w)+'</div><div class="d">'+esc(e.d)+'</div></div></div>'; }).join("")+
        '</div></div></section>'+

    '</div>'+

    '<div class="wrap"><div class="faqwrap"><h2>Common questions</h2><div id="cpd-faqs">'+
      FAQ.map(function(f,i){ return '<div class="faq'+(i===0?' open':'')+'" data-f="'+i+'"><button type="button" class="q" aria-expanded="'+(i===0?'true':'false')+'"><span>'+esc(f.q)+'</span><span class="sign" aria-hidden="true">'+(i===0?'–':'+')+'</span></button><div class="a">'+esc(f.a)+'</div></div>'; }).join("")+
      '</div><div style="border-top:1px solid var(--pdp-line)"></div>'+
      '<a class="faq-more" href="/pages/faqs">See all FAQs →</a></div>'+
      '<div class="shop-back"><a class="btn-outline" href="/collections/packs">See all packs</a></div>'+
      '<div class="disclaimer"><p class="disc">These statements have not been evaluated by the FDA. This product is not intended to diagnose, treat, cure, or prevent any disease.</p></div>'+
    '</div>';

  /* ---------------- pricing render + interactions ---------------- */
  var planInput = document.getElementById("cpd-plan-input");
  var barMeta = document.getElementById("cpd-bar-meta");
  function renderPrice(){
    var t = tiers[sel];
    document.getElementById("cpd-big").textContent = money(t.price);
    document.getElementById("cpd-unit").textContent = tierUnit(t);
    var line = perDay(t.price) + " a day";
    if (t.kind === "plan" && t.deliveries > 1) line = "Billed " + money(t.total) + " every " + t.deliveries + " months · " + line;
    document.getElementById("cpd-line").textContent = line;
    var avail = PDP.available;
    var ctaEl = document.getElementById("cpd-cta");
    if (avail){
      ctaEl.innerHTML = ctaText(t);
      ctaEl.classList.remove("soldout");
      document.getElementById("cpd-ship").textContent = shipNote(t);
    } else {
      ctaEl.innerHTML = "Sold out";
      ctaEl.classList.add("soldout");
      ctaEl.setAttribute("disabled", "");
      document.getElementById("cpd-ship").textContent = "Currently unavailable, back in stock soon.";
    }
    if (planInput) planInput.value = (t.kind === "plan") ? t.id : "";
    if (barMeta){
      barMeta.textContent = (t.kind === "onetime") ? money(t.price)+" one-time" : money(t.price)+"/mo";
    }
    var barCta = document.getElementById("cpd-bar-cta");
    if (barCta){
      if (avail){ barCta.textContent = (t.kind === "onetime") ? "Add to cart" : "Subscribe"; barCta.classList.remove("soldout"); }
      else { barCta.textContent = "Sold out"; barCta.classList.add("soldout"); }
    }
    Array.prototype.forEach.call(document.querySelectorAll("#cpd-tiers .tier"), function(el,i){ el.classList.toggle("active", i===sel); });
  }
  root.addEventListener("click", function(e){
    var tEl = e.target.closest ? e.target.closest(".tier") : null;
    if (tEl){ sel = +tEl.getAttribute("data-t"); renderPrice(); return; }
    var g = e.target.closest ? e.target.closest(".thumbs .t") : null;
    if (g){
      gActive = +g.getAttribute("data-g");
      scrollToSlide(gActive);
      setActiveThumb(gActive);
      return;
    }
    var fEl = e.target.closest ? e.target.closest(".faq") : null;
    if (fEl){
      var wasOpen = fEl.classList.contains("open");
      Array.prototype.forEach.call(root.querySelectorAll(".faq"), function(x){
        x.classList.remove("open");
        var s = x.querySelector(".sign"); if (s) s.innerHTML = "+";
        var b = x.querySelector(".q"); if (b) b.setAttribute("aria-expanded", "false");
      });
      if (!wasOpen){
        fEl.classList.add("open");
        var so = fEl.querySelector(".sign"); if (so) so.innerHTML = "–";
        var bo = fEl.querySelector(".q"); if (bo) bo.setAttribute("aria-expanded", "true");
      }
    }
  });

  /* gallery: swipe/scroll-snap track + thumbnail controls kept in sync */
  function galleryTrack(){ return root.querySelector(".gallery .main[data-track]"); }
  function scrollToSlide(i){ var tr = galleryTrack(); if (!tr) return; tr.scrollTo({ left: i * tr.clientWidth, behavior: "smooth" }); }
  function setActiveThumb(i){
    Array.prototype.forEach.call(root.querySelectorAll(".thumbs .t"), function(el,idx){
      var on = idx === i;
      el.classList.toggle("active", on);
      el.setAttribute("aria-current", on ? "true" : "false");
    });
  }
  (function(){
    var tr = galleryTrack(); if (!tr) return;
    var raf = 0;
    tr.addEventListener("scroll", function(){
      if (raf) return;
      raf = requestAnimationFrame(function(){
        raf = 0;
        var i = Math.round(tr.scrollLeft / (tr.clientWidth || 1));
        if (i !== gActive){ gActive = i; setActiveThumb(i); }
      });
    }, { passive: true });
  })();

  renderPrice();

  // mobile sticky bar submits the same product form
  var barBtn = document.getElementById("cpd-bar-cta");
  if (barBtn){
    barBtn.addEventListener("click", function(){
      var form = document.getElementById("product-form-main");
      if (form){ if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    });
  }
})();
